import React from 'react';
import IconTick from '../../svg/IconTick';
import Flex from '../../containers/Flex';

const pageSizePanel = {
    position: 'absolute',
    width: 70,
    backgroundColor: '#FFFFFF',
    borderRadius: '0 0 15px 15px',
    marginTop: 1,
    boxShadow: '0 8px 10px 0 rgba(0,0,0,0.33)',
    marginLeft: 18,
    paddingLeft: 17,
    zIndex: 600
};
const pageSizePanelInvert = {
    position: 'absolute',
    width: 70,
    backgroundColor: '#FFFFFF',
    borderRadius: '15px 15px 0 0',
    marginTop: -150,
    boxShadow: '0 0 10px 0 rgba(0,0,0,0.33)',
    marginLeft: 18,
    paddingLeft: 17,
    zIndex: 600
};
const pageSizePanelInvertShort = {
    ...pageSizePanelInvert,
    marginTop: -115
};

const pageSizeText = {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    marginLeft: 17
};
const activePageSize = {
    ...pageSizeText,
    color: '#FD9A00',
    cursor: 'auto'
};
const inactivePageSize = {
    ...pageSizeText,
    color: '#414141',
    cursor: 'pointer',
    paddingLeft: 12
};
const tickIcon = {
    width: 12,
    height: 19,
    verticalAlign: 'bottom',
    float: 'left'
};

const PageSizeOptionList = ({
    visible = false,
    options,
    selectedPageSize,
    onPageSizeChange,
    invert = false,
    invertShort = false
}) => {
    const spaceBetween = 17;

    const handleClick = (opt) => {
        onPageSizeChange(opt);
    };

    return (
        visible && (
            <div
                style={
                    invert
                        ? invertShort
                            ? pageSizePanelInvertShort
                            : pageSizePanelInvert
                        : pageSizePanel
                }
            >
                <div style={{ height: spaceBetween }} />
                {options.map((o, i) => {
                    return (
                        <React.Fragment key={`pageSize${i}`}>
                            <Flex>
                                <div>
                                    {o.value === selectedPageSize && (
                                        <IconTick style={tickIcon} />
                                    )}
                                    <span
                                        id={`pageSize${o.text}`}
                                        onClick={() => handleClick(o)}
                                        style={
                                            o.value === selectedPageSize
                                                ? activePageSize
                                                : inactivePageSize
                                        }
                                    >
                                        {o.text}
                                    </span>
                                </div>
                            </Flex>
                            <div style={{ height: spaceBetween }} />
                        </React.Fragment>
                    );
                })}
            </div>
        )
    );
};

export default PageSizeOptionList;
